import { call, put, takeLatest } from 'redux-saga/effects';
import get from 'lodash/get';
import axiosConfig from './axiosConfig';
import {
  FETCH_NDT_ANALYTICS,
  FETCH_AI_INSIGHTS
} from './types';
import {
  fetchNDTAnalyticsSuccess,
  fetchNDTAnalyticsFailure,
  fetchAIInsightsSuccess,
  fetchAIInsightsFailure
} from './actions';
import { Notification } from '../../components/ui/custom-notification';

// API functions
const api = {
  fetchNDTAnalytics: async (payload) => {
    try {
      // Use axios baseURL + dynamic filters from UI
      const url = 'api/reports/summary/ai';
      const res = await axiosConfig.post(url, payload ?? {});
      console.log('res', res);
      if (res.status === 200 || res.status === 201) {
        const responseData = get(res, ['data', 'data'], res.data);
        // Check if response indicates no records found
        if (responseData?.detail === 'No records found for the provided filters.' || 
            res.data?.detail === 'No records found for the provided filters.') {
        
        }
        return responseData;
      }
      
      return {
        detail: 'Failed to fetch NDT Analytics'
      };
    } catch (error) {
      
      return {
        detail: 'No records found for the provided filters.'
      };
  }
  },
  fetchAIInsights: async (payload) => {
    try {
      // Use axios baseURL + dynamic filters from UI
      const url = 'api/reports/summary/ml';
      const res = await axiosConfig.post(url, payload ?? {});
      if (res.status === 200 || res.status === 201) {
        const responseData = get(res, ['data', 'data'], res.data);
        console.log('responseData', responseData);
        // Check if response indicates no records found
        if (responseData?.detail === 'No records found for the provided filters.' || 
            res.data?.detail === 'No records found for the provided filters.') {
          throw new Error('No records found for the provided filters.');
        }
        return responseData;
      }
      
      throw new Error('Failed to fetch AI Insights');
    } catch (error) {
      if (error.message === 'No records found for the provided filters.') {
        throw error;
      }
      if (error.response) {
        const errorDetail = error.response.data?.detail || error.response.data?.message;
        if (errorDetail === 'No records found for the provided filters.') {
          throw new Error('No records found for the provided filters.');
        }
        throw new Error(errorDetail || 'Failed to fetch AI Insights');
      }
      throw error;
    }
  }
};

// Saga functions
function* fetchNDTAnalyticsSaga(action) {
  try {
    const response = yield call(api.fetchNDTAnalytics, action.payload);
    yield put(fetchNDTAnalyticsSuccess(response));
  } catch (error) {
    const errorMessage = error.message || 'Failed to fetch NDT Analytics';
    yield put(fetchNDTAnalyticsFailure(errorMessage));
    // Don't show notification for "No records found" - it's handled in the UI
    if (!errorMessage.includes('No records found')) {
      Notification.error(errorMessage);
    }
  }
}

function* fetchAIInsightsSaga(action) {
  try {
    const response = yield call(api.fetchAIInsights, action.payload);
    yield put(fetchAIInsightsSuccess(response));
  } catch (error) {
    const errorMessage = error.message || 'Failed to fetch AI Insights';
    yield put(fetchAIInsightsFailure(errorMessage));
    // Don't show notification for "No records found" - it's handled in the UI
    if (!errorMessage.includes('No records found')) {
      Notification.error(errorMessage);
    }
  }
}

// Watcher Saga
export default function* ndtAnalyticsSaga() {
  yield takeLatest(FETCH_NDT_ANALYTICS, fetchNDTAnalyticsSaga);
  yield takeLatest(FETCH_AI_INSIGHTS, fetchAIInsightsSaga);
}

